<template>
  <div>
    <div id="mobile">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div class="about">
      <div class="wrapper" id="js-wrapper">
        <div class="sections" id="js-slideContainer">
          <section class="section">
            <div class="titling">
              <h1>О нас</h1>
              <h2>
                Greysis - Разрабатывает интеллектуальные системы будущего
                цифровой экономики Узбекистана
              </h2>
            </div>
          </section>
          <section class="section">
            <div class="ab-d-1">
              <about-card
                pTag="Greysis разрабатывает комплекс интеллектуальных систем будущего цифровой экономики. Внедрив решения Greysis вы открывете новые возможности в электронной коммерции."
                title="Что такое Greysis" imageName="about1.png" class="ab-d-1cl" altTag="what is is">
              </about-card>
              <about-card
                pTag="Разработки Greysis позволят внедрить контроль и аналитику над всеми бизнес-процессами компании. Полученные интеллектуальными системами данные кардинально изменят прибыль вашей компании."
                title="Зачем нужен Greysis?" imageName="about2.png" class="ab-d-2cl" altTag="what is is">
              </about-card>
            </div>
            <div class="ab-d-2">
              <about-card
                pTag="Импортёры, производители, крупные поставщики, со всех уголков страны планирующие выйти на глобальный рынок электронной коммерции обратившись в Greysis получают доступ к интеллектуальным системам будущего цифровой экономики"
                title="Как стать частью Greysis?" imageName="about3.png" altTag="what is is">
              </about-card>
            </div>
          </section>
          <section class="section">
            <div class="morePages">
              <h1 class="info">
                Вам так же будет <br />
                интересно:
              </h1>
              <div class="more-cover">
                <div class="more-info">
                  <div class="more-item more-item1">
                    <router-link :to="{ path: '/home/0' }">
                      <div class="distorted-more-corners"></div>
                      <div class="distorted-more-img active"></div>
                      <div class="more-decr">
                        <h1>Фулфилмент</h1>
                        <h6>Полный комплекс услуг в электронной коммерции</h6>
                      </div>
                    </router-link>
                  </div>
                  <div class="more-item more-item2">
                    <router-link :to="{ path: '/home/1' }">
                      <div class="distorted-more-corners"></div>
                      <div class="distorted-more-img active"></div>
                      <div class="more-decr">
                        <h1>Колл-центр</h1>
                        <h6>Обработка заказов интернет-магазинов</h6>
                      </div>
                    </router-link>
                  </div>
                  <div class="more-item more-item3">
                    <router-link :to="{ path: '/home/2' }">
                      <div class="distorted-more-corners"></div>
                      <div class="distorted-more-img active"></div>
                      <div class="more-decr">
                        <h1>Консалтинг</h1>
                        <h6>
                          На любой ваш вопрос в электронной коммерции у нас уже
                          есть ответы
                        </h6>
                      </div>
                    </router-link>
                  </div>
                  <div class="more-item more-item4">
                    <router-link :to="{ path: '/home/3' }">
                      <div class="distorted-more-corners"></div>
                      <div class="distorted-more-img active"></div>
                      <div class="more-decr">
                        <h1>Инвесторам</h1>
                        <h6>
                          Вы крупный поставщик или импортёр продукции широкого
                          спроса, который хочет продавать онлайн?
                        </h6>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section">
            <div class="titling">
              <h1>Обратиться в Greysis:</h1>
              <div class="angle active">
                <router-link class="contact" to="/contact">Контакты</router-link>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="voice active">
        <div class="play-button"></div>
        <div id="waveform">
          <div class="wave-cover"></div>
        </div>
      </div>

      <div class="container" id="container"></div>

      <router-link class="active" to="/home/0">
        <img class="logo-text" src="../assets/greysislogotext.svg" alt="Greysis Logo Text" />
      </router-link>
      <ul class="nav">
        <li class="active ful">
          <router-link :to="{ path: '/home/0' }">Фулфилмент</router-link>
        </li>
        <li class="active call">
          <router-link :to="{ path: '/home/1' }">Колл-центр</router-link>
        </li>
        <li class="active cons">
          <router-link :to="{ path: '/home/2' }">Консалтинг</router-link>
        </li>
        <li class="active invest">
          <router-link :to="{ path: '/home/3' }">Инвесторам</router-link>
        </li>
        <li class="active current-page">
          <router-link to="/about">О нас</router-link>
        </li>
        <li class="contacts active">
          <router-link to="/contact">Контакты</router-link>
        </li>
      </ul>
      <div class="menu">
        <menu-icon></menu-icon>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import * as THREE from "three";
import { TimelineMax, gsap } from "gsap";
import ScrollMagic from "scrollmagic";
import { CSSPlugin } from "gsap/CSSPlugin";
// import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import WaveSurfer from "wavesurfer.js";
ScrollMagicPluginGsap(ScrollMagic, TimelineMax);

import menuIcon from "../components/menu.vue";
import aboutCard from "../components/aboutCard.vue";

export default {
  name: "about",
  data() {
    return {
      cube: null,
      renderer: null,
      scene: null,
      camera: null,
      geometry: null,
      time: 1000000,
      timeOut: null,
      i: 0,
      current: 0,
      gallery: [],
      isMusic: null,
    };
  },
  components: {
    menuIcon,
    aboutCard,
  },
  methods: {
    init: function () {
      gsap.registerPlugin(CSSPlugin);

      function loadImages(paths, whenLoaded) {
        var imgs = [];
        paths.forEach(function (path) {
          var img = new Image();
          img.onload = function () {
            imgs.push(img);
            if (imgs.length == paths.length) whenLoaded(imgs);
          };
          img.src = path;
        });
      }

      function fillUp(array, max) {
        var length = array.length;
        for (var i = 0; i < max - length; i++) {
          array.push(array[Math.floor(Math.random() * length)]);
        }
        return array;
      }
      function shuffle(a) {
        for (let i = a.length; i; i--) {
          let j = Math.floor(Math.random() * i);
          [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }
        return a;
      }

      let size = 70;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      canvas.width = size;
      canvas.height = size;
      canvas.classList.add("tempcanvas");
      function getArrayFromImage(img) {
        let imageCoords1 = [];
        let imageCoords2 = [];
        let imageCoords3 = [];

        ctx.clearRect(0, 0, size, size);
        ctx.drawImage(img, 0, 0, size, size);
        let data = ctx.getImageData(0, 0, size, size);

        data = data.data;

        for (var y = 0; y < size; y++) {
          for (var x = 0; x < size; x++) {
            var red = data[(size * y + x) * 4];
            var green = data[(size * y + x) * 4 + 1];
            var blue = data[(size * y + x) * 4 + 2];
            var alpha = data[(size * y + x) * 4 + 3];
            if (alpha > 0) {
              imageCoords1.push([10 * (x - size / 2), 10 * (size / 2 - y)]);
            }
          }
        }
        return shuffle(fillUp(imageCoords1, 3000));
      }

      let images = [
        "img/union.svg",
        "img/circle.svg",
        "img/elipse.svg",
        "img/satellite.svg",
        "img/copter.svg",
        "img/head.svg",
        "img/2.svg",
        "img/3.svg",
        "img/4.svg",
        "img/car.svg",
        "img/cube.svg",
        "img/headphones.svg",
      ];

      var load = this;

      loadImages(images, function (loadedImages) {
        loadedImages.forEach(function (el, index) {
          load.gallery.push(getArrayFromImage(loadedImages[index]));
        });

        var current = 0;
        load.timeOut = setInterval(function () {
          current++;
          current = current % load.gallery.length;
          load.geometry.vertices.forEach(function (particle, index) {
            let tl = new TimelineMax();
            tl.to(particle, 1, {
              x: load.gallery[current][index][0],
              y: load.gallery[current][index][1],
            });
          });
        }, load.time);

        load.scene = new THREE.Scene();
        load.scene.transparent = true;

        load.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
        });
        load.renderer.setClearColor(0x000000, 0);
        load.renderer.setPixelRatio(window.devicePixelRatio);
        load.renderer.setSize(window.innerWidth, window.innerHeight);

        var container = document.getElementById("container");
        container.appendChild(load.renderer.domElement);

        load.camera = new THREE.PerspectiveCamera(
          100,
          window.innerWidth / window.innerHeight,
          1,
          1000
        );
        load.camera.position.z = 400;

        // ЧТО ЕСТЬ НА СЦЕНЕ
        var texture = new THREE.TextureLoader().load("img/particle.png");
        var material = new THREE.PointsMaterial({
          size: 5,
          color: new THREE.Color(0x00c2ff),
          map: texture,
          alphaTest: 0.9,
        });

        load.geometry = new THREE.Geometry();
        var x, y, z;

        load.gallery[0].forEach((el, index) => {
          load.geometry.vertices.push(
            new THREE.Vector3(el[0], el[1], Math.random() * 1)
          );
        });

        var pointCloud = new THREE.Points(load.geometry, material);
        load.scene.add(pointCloud);
      });

      window.addEventListener("resize", onWindowResize, false);
      function onWindowResize() {
        load.camera.aspect = window.innerWidth / window.innerHeight;
        load.camera.updateProjectionMatrix();
        load.renderer.setSize(window.innerWidth, window.innerHeight);
      }
    },
    animate: function () {
      this.i++;
      requestAnimationFrame(this.animate);
      var load = this;
      setTimeout(function () {
        load.geometry.vertices.forEach(function (particle, index) {
          var dX, dY, dZ;
          dX = Math.sin(load.i / 10 + index / 2) / 10;
          dY = 0;
          dZ = 0;
          particle.add(new THREE.Vector3(dX, dY, dZ));
        });
        load.geometry.verticesNeedUpdate = true;
        load.renderer.render(load.scene, load.camera);
      }, 1000);
    },
  },
  mounted() {
    this.init();
    this.animate();

    // Progress
    var circle = document.getElementById("circle");
    var radius = circle.r.baseVal.value;
    var circumference = radius * 2 * Math.PI;

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;

    function setProgress(percent) {
      const offset = circumference - (percent / 100) * circumference;
      circle.style.strokeDashoffset = offset;
    }
    setProgress(0);

    var controller = new ScrollMagic.Controller();

    var horizontalSlide = new TimelineMax()
      // animate panels
      .to("#js-slideContainer", 1, { x: "-20%", ease: "Power0.easeIn" })
      .to("#js-slideContainer", 1, { x: "-40%", ease: "Power0.easeIn" })
      .to("#js-slideContainer", 1, { x: "-60%", ease: "Power0.easeIn" });

    new ScrollMagic.Scene({
      triggerElement: "#js-wrapper",
      triggerHook: "onLeave",
      duration: "300%",
    })
      .setPin("#js-wrapper")
      .setTween(horizontalSlide)
      .addTo(controller);

    var fstCont = new TimelineMax();
    fstCont.fromTo(
      "#container",
      { scale: 1, x: "0%", y: "0%" },
      {
        scale: 0.3,
        left: "-25%",
        top: "25%",
        duration: 1,
        ease: "Power1.easeInOut",
      },
      0
    );
    fstCont.fromTo(
      ".ab-d-1",
      { alpha: 0, x: 0 },
      { alpha: 1, x: 0, duration: 1, ease: "Power1.easeInOut" },
      0
    );
    fstCont.fromTo(
      ".ab-d-2",
      { alpha: 0, x: 0 },
      { alpha: 1, x: 0, duration: 1, ease: "Power1.easeInOut" },
      0
    );

    new ScrollMagic.Scene({
      triggerElement: "#js-wrapper",
      offset: $(".titling").offset().top + 100,
    })
      .setTween(fstCont)
      .addTo(controller)
      .reverse(true);

    var fstCont4 = new TimelineMax();
    fstCont4.to("#container", { scale: 1, x: "40%", y: "-25%" });

    new ScrollMagic.Scene({
      triggerElement: "#js-wrapper",
      triggerHook: "onLeave",
      offset: window.innerHeight * 3,
    })
      .setTween(fstCont4)
      .addTo(controller);

    $(".menu-icon").show();
    // Mouse over
    $(".active").mouseover(function () {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(2)");
    });
    $(".active").mouseleave(function () {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(1)");
    });

    var myAudio = document.getElementById("audio");

    if (myAudio.paused) {
      this.isMusic = false;
    } else {
      this.isMusic = true;
    }

    $(".audio").click(function () {
      if (myAudio.paused) {
        load.isMusic = false;
      } else {
        load.isMusic = true;
      }
    });

    var wavesurfer = WaveSurfer.create({
      container: "#waveform",
      barWidth: 3,
      barHeight: 0.5,
      barGap: 5,
      waveColor: "rgba(244,255,255,0.3)",
      progressColor: "white",
      cursorWidth: 0,
    });
    wavesurfer.load("about.mp3");
    wavesurfer.setVolume(0.15);

    $(".nav li").click(function () {
      wavesurfer.destroy();
    });

    $("#menu #menu-cover ul li").click(function () {
      wavesurfer.destroy();
    });

    $(".more-item").click(function () {
      wavesurfer.destroy();
    });

    $(".contact").click(function () {
      wavesurfer.destroy();
    });

    let load = this;

    var music = new TimelineMax();
    music.set(".play-button", { scale: 1 });
    music.to(".play-button", 0.3, { delay: 0.5, scale: 1.2 });
    music.to(".play-button", 0.3, { scale: 1 });
    music.to(".play-button", 0.3, { scale: 1.2 });
    music.to(".play-button", 0.3, {
      scale: 1,
      onComplete: function () {
        music.play(0);
      },
    });

    wavesurfer.on("finish", function () {
      clearInterval(load.timeOut);
      load.current++;
      load.current = load.current % load.gallery.length;
      load.geometry.vertices.forEach(function (particle, index) {
        let tl = new TimelineMax();
        tl.to(particle, 1, {
          x: load.gallery[0][index][0],
          y: load.gallery[0][index][1],
        });
      });
      $(".play-button").css(
        "background-image",
        "url(" + require("../assets/play.svg") + ")"
      );
      music.play(0);
    });

    $(".play-button").on("click", function () {
      if (!wavesurfer.isPlaying()) {
        wavesurfer.play();
        myAudio.pause();
        $(".play-button").css(
          "background-image",
          "url(" + require("../assets/pause.svg") + ")"
        );
        music.pause(0);

        load.current++;
        load.current = load.current % load.gallery.length;

        load.geometry.vertices.forEach(function (particle, index) {
          let tr = new TimelineMax();
          tr.to(particle, 1, {
            x: load.gallery[load.current][index][0],
            y: load.gallery[load.current][index][1],
          });
        });

        load.timeOut = setInterval(function () {
          load.current++;
          load.current = load.current % load.gallery.length;
          load.geometry.vertices.forEach(function (particle, index) {
            let tf = new TimelineMax();
            tf.to(particle, 1, {
              x: load.gallery[load.current][index][0],
              y: load.gallery[load.current][index][1],
            });
          });
        }, 3500);
      } else {
        if (load.isMusic) {
          myAudio.play();
          myAudio.volume = 0.05;
        } else {
          myAudio.pause();
        }
        wavesurfer.pause();
        music.play(0);
        $(".play-button").css(
          "background-image",
          "url(" + require("../assets/play.svg") + ")"
        );
        clearInterval(load.timeOut);
        load.current++;
        load.current = load.current % load.gallery.length;
        load.geometry.vertices.forEach(function (particle, index) {
          let tl = new TimelineMax();
          tl.to(particle, 1, {
            x: load.gallery[0][index][0],
            y: load.gallery[0][index][1],
          });
        });
      }
    });
  },
  destroyed() {
    this.renderer.forceContextLoss();
  },
};
</script>

<style scoped>
.ab-d-2cl {
  transform: translateX(20%);
}

.info {
  margin-left: 5vw;
  margin-top: 15vh;
}

.more-decr {
  margin-top: 20vw;
}

.more-decr h1 {
  font-size: 1.5em;
}

.more-decr h6 {
  margin-top: 10px;
  font-weight: 100;
  font-size: 0.9em;
  padding-right: 20px;
  line-height: 23px;
}

.distorted-more-img {
  background-size: cover;
  background-position: right center;
  filter: grayscale(1);
  height: 90%;
  width: 90%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) scale(0.9);
  transition: 0.3s;
}

.distorted-more-img:hover {
  transform: translateY(-50%) scale(1);
  filter: grayscale(0);
}

.distorted-more-corners {
  height: 90%;
  width: 90%;
  background: linear-gradient(to right, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to right, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to left, #739fac 1px, transparent 1px) 100% 100%,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 0 0,
    linear-gradient(to bottom, #739fac 1px, transparent 1px) 100% 0,
    linear-gradient(to top, #739fac 1px, transparent 1px) 0 100%,
    linear-gradient(to top, #739fac 1px, transparent 1px) 100% 100%,
    linear-gradient(to top, #739fac 1px, transparent 1px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  z-index: 2;
  position: absolute;
  pointer-events: none;
  margin: 1vw auto;
}

.more-cover {
  height: 100%;
  width: 90vw;
  margin-left: calc(5vw + 1%);
  margin-top: 50px;
  margin-bottom: 120px;
}

.more-info {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.more-info .more-item {
  height: 20vw;
  position: relative;
}

.more-item1 .distorted-more-img {
  background-image: url("../assets/more-ful.png");
}

.more-item2 .distorted-more-img {
  background-image: url("../assets/more-call.png");
}

.more-item3 .distorted-more-img {
  background-image: url("../assets/more-cons.png");
}

.more-item4 .distorted-more-img {
  background-image: url("../assets/more-invest.png");
}

.morePages {
  margin-top: 50px;
}

.ab-d-1 {
  position: absolute;
  left: -20%;
  top: 50%;
  transform: translateY(-50%);
}

.ab-d-1 .aboutCard:nth-child(2) {
  position: relative;
  left: 15%;
}

.ab-d-2 {
  position: absolute;
  top: 50%;
  transform: translateY(-100%);
  left: 40%;
  width: 100%;
}

.titling {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  left: 10%;
  width: 25%;
}

.titling h1 {
  font-size: 2em;
  font-family: Montserrat-Light;
  font-weight: 100;
}

.titling h2 {
  margin-top: 20px;
  font-size: 1em;
  font-family: Montserrat-Light;
  font-weight: 100;
}

#container {
  position: fixed;
  top: 0;
  right: 0;
  width: 85vw;
  height: 100vh;
  pointer-events: none;
}

.wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  -webkit-perspective: 1000;
  perspective: 1000;
  max-width: unset !important;
}

.section {
  height: 100vh;
  width: calc((100% / 5));
  float: left;
  position: relative;
  max-width: unset !important;
}

.angle {
  background-color: #2778f3;
  font-size: 0.7em;
}

.sections {
  width: calc(500%);
  height: 100vh;
  max-width: unset !important;
}

.logo-text {
  width: 13vw;
  position: fixed;
  top: 30px;
  left: 30px;
}

.nav {
  position: fixed;
  left: 20vw;
  top: 30px;
  width: 74vw;
}

.nav li {
  font-size: calc(0.6vw + 0.5vh + 0.5vmin);
  display: inline-block;
  padding: 0 15px;
  color: #dedede;
  opacity: 0.5;
  cursor: pointer;
  transition: 0.3s;
}

.nav li:hover {
  color: white;
  opacity: 1;
}

.contacts {
  float: right;
  text-transform: capitalize;
  font-family: Montserrat-SemiBold;
  color: white;
}

.contact {
  font-size: calc(0.7vw + 0.6vh + 0.4vmin);
}

#mobile {
  display: none;
}

.contact {
  display: block;
}

.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

#mobile {
  display: none;
}

.about {
  display: block;
}

.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

.wave-cover {
  width: calc(100% + 1px);
  height: 64px;
  position: absolute;
  background-color: #1e1e1e;
  z-index: 10;
  bottom: 0;
  right: 0;
}

#waveform {
  width: 75%;
  position: absolute;
  right: 0;
  display: inline-block;
}

.play-button {
  width: 20%;
  height: 30px;
  display: inline-block;
  background-image: url("../assets/play.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  top: 40px;
}

.voice {
  position: fixed;
  top: 85%;
  left: 10%;
  width: 20%;
  height: 100%;
  z-index: 10;
}

@media only screen and (max-width: 900px) {
  #mobile {
    display: block;
  }

  .about {
    display: none;
  }
}
</style>
